import React from 'react'

const Imprint = () => {
  return <div style={{ fontSize: '50px' }}>Imprint</div>
}

export default Imprint
